module.exports = __webpack_public_path__ + "static/media/wheat.656f0b16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/wheat.svg
// module id = 1117
// module chunks = 0